import { atom } from "jotai";
import { AccountLabel } from "@/entities/Labeling/Account.model";
import { FinanceLabField } from "@/entities/FinanceLab";
import { Metric } from "@/entities/Finance/Finance.model";

export const showDataSourcesAtom = atom<boolean>(false);

export const selectedMetricLabelAtom = atom<
    AccountLabel | FinanceLabField | null
>(AccountLabel.REVENUES);

export type SelectedMetricForDrawer = {
    metric: Metric | undefined;
    title: string;
} | null;

export const selectedMetricForDrawerAtom = atom<SelectedMetricForDrawer>(null);

export type SelectedMetricForLineage = {
    metric: Metric | null;
    period: string;
    title: string;
} | null;

export const selectedMetricForLineageAtom =
    atom<SelectedMetricForLineage>(null);

export const showInvestmentCriteriaDrawerAtom = atom<boolean>(false);
